// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2av8o","col":"styles_col__YJiib"};